import { render, staticRenderFns } from "./SignUpViaActivationCode.vue?vue&type=template&id=bb36afcc&scoped=true&"
import script from "./SignUpViaActivationCode.vue?vue&type=script&lang=ts&"
export * from "./SignUpViaActivationCode.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpViaActivationCode.vue?vue&type=style&index=0&id=bb36afcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb36afcc",
  null
  
)

export default component.exports